import React from "react";
import { UI_INPUT } from "lib/uiClasses";

function InputField(props: {
  id: string;
  label: string;
  extra: string;
  placeholder: string;
  variant: string;
  state?: string;
  disabled?: boolean;
  type?: string;
  value?: string;
  autoComplete?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) {
  const { label, id, extra, type, placeholder, variant, state, disabled, value, autoComplete, onChange } =
    props;

  return (
    <div className={`${extra}`}>
      <label
        htmlFor={id}
        className={`text-sm text-navy-700 dark:text-white ${
          variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-bold"
        }`}
      >
        {label}
      </label>
      <input
        disabled={disabled}
        type={type}
        id={id}
        placeholder={placeholder}
        value={value}
        autoComplete={autoComplete}
        onChange={onChange}
        className={`mt-2 flex h-12 w-full items-center justify-center p-3 text-sm outline-none ${UI_INPUT} ${
          variant === "auth"
            ? "dark:!border-white/10 dark:!bg-[#0a1523] dark:!text-white dark:placeholder:!text-white/35"
            : ""
        } ${
          disabled === true
            ? "!border-none !bg-gray-100 dark:!bg-white/[0.04] dark:placeholder:!text-slate-600"
            : state === "error"
            ? "border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
            : state === "success"
            ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
            : ""
        }`}
      />
    </div>
  );
}

export default InputField;
